<template>
<v-app>
    
            <download-excel
                class="btn btn-default"
                :data="json_data"
                :fields="fieldHeaders"
                worksheet="My Worksheet"
                type="xls"
                :name="fileName+'.xls'"
                :footer="footer"
            >
             <v-card class="elevation-0 py-4 px-3 rounded-xl" color="rgb(219, 241, 254)" >
                <v-layout>
                    <v-flex lg6 xs8 class="ml-lg-5 ml-2">
                           <v-img src="@/assets/images/Monitoring/excel.svg" max-height="80" contain /> 
                    </v-flex>
                </v-layout>
            </v-card>

            </download-excel>
    
</v-app>
</template>
<style  scoped>
.btn-default{
    cursor: pointer;
}
</style>
<script>
import Vue from "vue";
import JsonExcel from "vue-json-excel";
 
Vue.component("downloadExcel", JsonExcel);
export default {
    props:["tablesData","totalAverage","fileName","fieldHeaders"],
    data: () => {
        return {
                ta:"Total Average : ",
                // json_data:'',
                    json_meta: [
                    [
                        {
                        key: "charset",
                        value: " ISO 10646-1",
                        },
                    ],
                    ],

        }
    },
    computed:{
        json_data(){
            return this.tablesData
        },
        footer(){
            return this.ta.bold()+" "+this.totalAverage
        }
    }
}
</script>